const main = document.querySelector(".site-main");
const progress = document.querySelector(".reading-progress");
let inViewport = false;
let progressPercentage = 0;

let observer = new IntersectionObserver(handler);

observer.observe(main);

//Whenever <main> comes in or out of view, this handler is invoked.
function handler(entries, observer) {
	entries.forEach(entry => {
		if (entry.isIntersecting) {
			inViewport = true;
		} else {
			inViewport = false;
		}
	});
}

// Get the percentage scrolled of an element. It returns zero if its not in view.
function getScrollProgress(el) {
	if (inViewport) {

		let coords = el.getBoundingClientRect();
		let height = coords.height;

		if (coords.top < 0) {
			progressPercentage = (Math.abs(coords.top) / height) * 100;
		}
	}
	return progressPercentage;
}

function showReadingProgress() {
	progress.setAttribute("value", getScrollProgress(main));
}

//scroll event listener
var timeout;

window.onscroll = function () {
	if (timeout) {
		window.cancelAnimationFrame(timeout);
	}

	timeout = window.requestAnimationFrame(function () {
		showReadingProgress();
	});
};